import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
export var getHotjarSettingsValues = function getHotjarSettingsValues() {
  return getGlobalProperty("hotjarSettingsValues") || {};
};